import React, { Dispatch, SetStateAction, useState } from "react";
import DefaultButton from "../../default-button/DefaultButton";
import Plus from "../../../assets/icons/Plus";
import Delete from "../../../assets/icons/Delete";
import Rename from "../../../assets/icons/Rename";
import arrowUp from "../../../assets/svg/arrow-up-blue-bg.svg";
import arrowDown from "../../../assets/svg/arrow-down-squared.svg";
import CategoryItemsTable from "./CategoryItemsTable";
import { Category, Item } from "../../../misc/types";
import RenameCategoryModal from "./RenameCategoryModal";
import AddItemModal from "./AddItemModal";
import EditItemModal from "./EditItemModal";
import { SocialCategory } from "../../../types";
import { accessGlobalMiscState, useGlobalMiscState } from "../../../stores/misc";
import { simpleGetter } from "../../../actions/common";
import { socialTranscriptApi } from "../../../api/api";
import { showSnackbar } from "../../../misc/utils";
import { HasRole } from "../../HasRole";

type Props = {
  category: SocialCategory;
  openedCategory: string;
  setOpenedCategory: (value: string) => void;
};

export default function CategoryCard({
  category,
  openedCategory,
  setOpenedCategory,
}: Props) {
  const miscState = useGlobalMiscState();
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentItemToEdit, setCurrentItemToEdit] = useState<Item | null>(null);

  const openEditModal = (item: Item) => {
    setCurrentItemToEdit(item);
    setIsEditModalOpen(true);
  };

  const isActive = openedCategory === category.name;

  const handleCategoryClick = () => {
    openedCategory === category.name
      ? setOpenedCategory("")
      : setOpenedCategory(category.name);
  };

  // const deleteCategory = () => {
  //   setCategories((prevCategories) =>
  //     prevCategories.filter((item) => item.id !== category.id)
  //   );
  // };

  // const renameCategory = (newTitle: string) => {
  //   if (newTitle) {
  //     setCategories((prevCategories) =>
  //       prevCategories.map((item) =>
  //         item.id === category.id ? { ...item, title: newTitle } : item
  //       )
  //     );
  //     setIsRenameModalOpen(false);
  //   }
  // };

  // const addItem = (newItem: Item) => {
  //   if (newItem) {
  //     setCategories((prevCategories) =>
  //       prevCategories.map((item) =>
  //         item.id === category.id
  //           ? { ...item, items: [...category.subcategories, newItem] }
  //           : item
  //       )
  //     );
  //   }
  //   setIsAddItemModalOpen(false);
  // };

  // const deleteItem = (itemId: number) => {
  //   setCategories((prevCategories) =>
  //     prevCategories.map((category) =>
  //       category.id === category.id
  //         ? {
  //           ...category,
  //           items: category.subcategories.filter((item) => item.id !== itemId),
  //         }
  //         : category
  //     )
  //   );
  // };

  // const handleEditItem = (categoryId: number, updatedItem: Item) => {
  //   setCategories((prevCategories) =>
  //     prevCategories.map((category) =>
  //       category.id === categoryId
  //         ? {
  //           ...category,
  //           items: category.subcategories.map((item) =>
  //             item.id === updatedItem.id ? updatedItem : item
  //           ),
  //         }
  //         : category
  //     )
  //   );
  // };

  const onRename = () => {
    miscState.setBatch({
      socialTranscriptIsAddModalOpen: true,
      socialTranscriptCurrentCategory: category
    })
  }

  const onAddSubcategory = () => {
    miscState.setBatch({
      socialTranscriptIsAddSubcategoryModalOpen: true,
      socialTranscriptCurrentCategory: category,
      socialTranscriptCurrentSubcategory: null
    })
  }

  const onDelete = async () => {
    const response = await simpleGetter(socialTranscriptApi.deleteModel, {
      model: 'SocialCategory',
      body: {
        id: category.id
      }
    })
    showSnackbar(response.success ? 'Успешно' : 'Произошла ошибка', response.success ? 'success' : 'error')
    if (response.success) {
      accessGlobalMiscState().set('socialTranscriptTriggerFetch', (accessGlobalMiscState().get('socialTranscriptTriggerFetch') || 0) + 1)
    }
  }

  return (
    <div className=" p-4 bg-[#F0F3FA80] mt-4 rounded-xl">
      <div className="flex justify-between items-center ">
        <div className="flex items-center gap-4 font-medium text-[15px]">
          <img
            onClick={handleCategoryClick}
            src={isActive ? arrowUp : arrowDown}
            alt="arrow-up"
            className="cursor-pointer"
          />
          <p>{category.name}</p>
        </div>
        <div className="flex items-center font-medium text-[15px]">
          <p className="text-[#5F6B88] font-medium text-[15px]">
            Пунктов в категории:
          </p>
          <p className="font-medium text-[15px]">{category.subcategories.length}</p>
        </div>
        <HasRole roles={['create_social_transcript_categories']}>
          <div className="flex items-center gap-2 text-nowrap">
            <DefaultButton
              buttonText="Переименовать"
              additionalStyle="text-[#5F6B88] border-1 border-[#AFB7CA] py-[6px] px-4 font-medium gap-2"
              Icon={Rename}
              onClick={onRename}
            />
            <DefaultButton
              buttonText="Добавить пункт"
              additionalStyle="text-[#3BBC30] border-1 border-[#3BBC30] py-[6px] px-4 font-medium gap-2"
              Icon={Plus}
              onClick={onAddSubcategory}
            />
            {!category.subcategories.some(s => s.transcript_items?.length) && (
              <DefaultButton
                buttonText="Удалить"
                additionalStyle="text-[#F12D2D] border-1 border-[#F12D2D] py-[6px] px-4 font-medium gap-2"
                Icon={Delete}
                onClick={onDelete}
              // onClick={() => deleteCategory()}
              />
            )}
          </div>
        </HasRole>
      </div>
      {isActive && (
        <CategoryItemsTable
          categoryItems={category.subcategories}
          category={category}
        />
      )}
      {/* {isAddItemModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
          <AddItemModal
            category={category}
            setIsAddItemModalOpen={setIsAddItemModalOpen}
            addItem={addItem}
          />
        </div>
      )} */}
      {/* {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
          <EditItemModal
            category={category}
            setIsEditModalOpen={setIsEditModalOpen}
            currentItemToEdit={currentItemToEdit}
            handleEditItem={handleEditItem}
          />
        </div>
      )} */}
    </div>
  );
}
